import React, {
	useMemo,
	useState,
	useCallback,
	useRef,
	useEffect,
} from 'react';
import {
	CustomTooltipWithLabel,
	useAppSelector,
} from '../../../globalUtils/globalExports';

import './NocChargerPerfomanceSidePanel.css';
import {
	HorizontalNavbar,
	useAppDispatch,
	// LinkButton
} from '../../../globalUtils/globalExports';
import {
	DataGridPro,
	GridValidRowModel,
	type GridRenderCellParams,
} from '@mui/x-data-grid-pro';
import { getacNocDashboardReducer } from '../../rmsReduxStore/acReduxExports';
import { setChargerIdsForRedirection } from '../../rmsReduxStore/acNocDashboardRedux/acNocDashboardCreator';


interface NocChargerReportProps {
	handlePerformanceRankingNavChange: (value) => void;
}

const AcNocChargerReport: React.FC<NocChargerReportProps> = ({
	handlePerformanceRankingNavChange,
}) => {
	const {
		nocDashboardChargerUptimePerfomanceRankingsData,
		nocDashboardChargerUtilisationPerfomanceRankingsData,
		nocDashboardChargerEfficiencyPerfomanceRankingsData,
	} = useAppSelector(getacNocDashboardReducer);

	const topTableRef = useRef<HTMLDivElement | null>(null);
	const underTableRef = useRef<HTMLDivElement | null>(null);

	const [topRowHeight, setTopRowHeight] = useState(23);
	const [underRowHeight, setUnderRowHeight] = useState(23);

	const HEADER_HEIGHT = 30;
	const SMALL_SCREEN_ROW_HEIGHT = 23;
	const BIG_SCREEN_ROW_HEIGHT = 24;

	const dispatch = useAppDispatch();

	const [selectedNav, setSelectedNav] = useState<
		'uptime' | 'utilisation' | 'chargingEfficiency'
	>('uptime');
	const userInteractedRef = useRef(false);
	const navOrder: Array<'uptime' | 'utilisation' | 'chargingEfficiency'> = [
		'uptime',
		'utilisation',
		'chargingEfficiency',
	];

	const headerdata = [
		{
			id: 'uptime',
			text: 'Uptime',
			isAccessible: true,
		},
		{
			id: 'utilisation',
			text: 'Utilisation',
			isAccessible: true,
		},
		{
			id: 'chargingEfficiency',
			text: 'Charging Efficiency',
			isAccessible: true,
		},
	];
	const handleNavBtnClick = useCallback((val) => {
		userInteractedRef.current = true; // stop auto rotation
		setSelectedNav(val);
		handlePerformanceRankingNavChange(getFetchType(val));
	}, []);

	const getFetchType = (val) => {
		switch (val) {
			case 'chargingEfficiency':
				return 'efficiency';
			default:
				return val;
		}
	};

	const getHeaderName = (val) => {
		switch (val) {
			case 'chargingEfficiency':
				return 'Efficiency %';
			case 'uptime':
				return 'Uptime %';
			case 'utilisation':
				return 'Utilisation %';
		}
	};

	const handleChargerClicked = (chargerSerialId, chargerId) => {
		dispatch(setChargerIdsForRedirection([chargerId]));
		window.open(
			`/ac/charger?chargerId=${chargerSerialId}&redirectedFrom=nocDashboard`,
			'_blank',
		);
	};
	const performanceDataByNav = useMemo(() => {
		switch (selectedNav) {
			case 'utilisation':
				return nocDashboardChargerUtilisationPerfomanceRankingsData;
			case 'chargingEfficiency':
				return nocDashboardChargerEfficiencyPerfomanceRankingsData;
			case 'uptime':
			default:
				return nocDashboardChargerUptimePerfomanceRankingsData;
		}
	}, [
		selectedNav,
		nocDashboardChargerUptimePerfomanceRankingsData,
		nocDashboardChargerUtilisationPerfomanceRankingsData,
		nocDashboardChargerEfficiencyPerfomanceRankingsData,
	]);
	const topPerformingChargerList =
		performanceDataByNav?.topPerformingChargers ?? [];

	const underPerformingChargerList =
		performanceDataByNav?.underPerformingChargers ?? [];

	const getTopPerfomingChargerRows = useCallback((): IPerfomingChargers[] => {
		return topPerformingChargerList !== null &&
			topPerformingChargerList?.length > 0
			? topPerformingChargerList.slice(0, 4)
			: [];
	}, [topPerformingChargerList]);

	const getUnderPerformingChargerRows =
		useCallback((): IPerfomingChargers[] => {
			return underPerformingChargerList !== null &&
				underPerformingChargerList?.length > 0
				? underPerformingChargerList.slice(0, 4)
				: [];
		}, [underPerformingChargerList]);

	const perfomingChargerColumns = useMemo(() => {
		const columns = [
			// {
			//   field: 'chargerVisibleId',
			//   flex: 1,
			//   sortable:false,
			//   maxWidth: 200,
			//   headerName: 'Charger',
			//   minWidth: 100,
			//   hideable: false,
			//   pinnable: false,
			//           renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
			//     const rowData = params?.row;
			//     return (
			//       rowData?.productType ?
			//         (<div
			//           className="individual__charger__wrap"
			//           onClick={(e) => {
			//             e?.stopPropagation()
			//             const action = {
			//               type: chargerTypes.SET_CHARGER_REDUCER_STATE,
			//               isChargerTablePropsRetained: true
			//             }
			//             dispatch(action)
			//           }
			//           }
			//         >
			//           <LinkButton
			//             linkBtnId={rowData?.chargerVisibleId}
			//             link={'/charger?chargerId=' + rowData.chargerVisibleId}
			//             btnClassName="individual__charger__text"
			//             btnText={rowData?.chargerVisibleId}
			//             linkBtnState={{ chargerId: rowData?.id, charger: rowData }}
			//           />
			//         </div>) : (<div>{rowData?.chargerVisibleId}</div>)
			//     );
			//   },

			// },
			{
				field: 'charger',
				flex: 1,
				sortable: false,
				maxWidth: 180,
				headerName: 'Charger',
				minWidth: 90,
				hideable: false,
				pinnable: false,
				renderCell: (
					params: GridRenderCellParams<GridValidRowModel>,
				): JSX.Element => {
					const rowData = params?.row;
					return (
						<div
							className='noc-charger-report-charger-label'
							onClick={() => {
								handleChargerClicked(rowData?.charger, rowData?.id);
							}}
						>
							<CustomTooltipWithLabel
								label={rowData?.charger}
								labelId='noc-charger-report-charger'
							/>
						</div>
					);
				},
			},
			{
				field: 'chargingStation',
				flex: 1,
				sortable: false,
				maxWidth: 120,
				headerName: 'Station',
				minWidth: 70,
				hideable: false,
				pinnable: false,
			},
			{
				field: 'customer',
				flex: 1,
				sortable: false,
				maxWidth: 120,
				headerName: 'Customer',
				minWidth: 80,
				hideable: false,
				pinnable: false,
			},
			// {
			// 	field: 'productType',

			// 	flex: 1,
			// 	sortable: false,
			// 	maxWidth: 150,
			// 	headerName: 'Product Type',
			// 	minWidth: 100,
			// 	hideable: false,
			// 	pinnable: false,
			// 	renderCell: (
			// 		params: GridRenderCellParams<GridValidRowModel>
			// 	): JSX.Element => {
			// 		const rowData = params?.row;
			// 		return (
			// 			<CustomTooltipWithLabel
			// 				label={rowData?.productType}
			// 				labelId={rowData?.id}
			// 			/>
			// 		);
			// 	},
			// },
			{
				field: 'value',
				flex: 1,
				sortable: false,
				maxWidth: 160,
				headerName: getHeaderName(selectedNav),
				minWidth: 100,
				hideable: false,
				pinnable: false,
				renderCell: (
					params: GridRenderCellParams<GridValidRowModel>,
				): JSX.Element => {
					const rowData = params?.row;
					return (
						<CustomTooltipWithLabel
							label={String(isNaN(Number(rowData?.value)) ? rowData?.value ?? '--' : Number(rowData?.value).toFixed(2))}
							labelId={rowData?.id}
						/>
					);
				},
			},
		];

		return columns;
	}, [selectedNav]);

	const navBarconfigurations = useMemo(() => {
		return {
			selectedNav: selectedNav,
			navList: headerdata?.filter((nav) => nav?.isAccessible),
			onNavClick: handleNavBtnClick,
		};
	}, [selectedNav]);

	useEffect(() => {
		const intervalId = setInterval(
			() => {
				// Stop auto-toggle if user has clicked
				if (userInteractedRef.current) return;

				setSelectedNav((prev) => {
					const currentIndex = navOrder.indexOf(prev);
					const nextIndex = (currentIndex + 1) % navOrder.length;
					handlePerformanceRankingNavChange(getFetchType(navOrder[nextIndex]));
					return navOrder[nextIndex];
				});
			},
			1 * 5 * 1000,
		); // 1 minute

		return () => clearInterval(intervalId);
	}, []);

	// useEffect(()=>{
	// const perfomancefilters = getCurrentFiltersValues('nocPerfomanceAnalytics', false)
	// dispatch(fetchNocDashboardChargerPerfomanceRankings({fetchType:getFetchType(selectedNav),filters:perfomancefilters,searchTerm:''}));
	// },[selectedNav])
	useEffect(() => {
		const updateRowHeights = () => {
			if (topTableRef.current) {
				const parentHeight = topTableRef.current.clientHeight;
				const rows = getTopPerfomingChargerRows().length || 1;

				const calculatedHeight = Math.floor(
					(parentHeight - HEADER_HEIGHT) / rows,
				);

				setTopRowHeight(
					calculatedHeight >= BIG_SCREEN_ROW_HEIGHT
						? BIG_SCREEN_ROW_HEIGHT
						: SMALL_SCREEN_ROW_HEIGHT,
				);
			}

			if (underTableRef.current) {
				const parentHeight = underTableRef.current.clientHeight;
				const rows = getUnderPerformingChargerRows().length || 1;

				const calculatedHeight = Math.floor(
					(parentHeight - HEADER_HEIGHT) / rows,
				);

				setUnderRowHeight(
					calculatedHeight >= BIG_SCREEN_ROW_HEIGHT
						? BIG_SCREEN_ROW_HEIGHT
						: SMALL_SCREEN_ROW_HEIGHT,
				);
			}
		};

		updateRowHeights();

		const resizeObserver = new ResizeObserver(updateRowHeights);

		if (topTableRef.current) resizeObserver.observe(topTableRef.current);
		if (underTableRef.current) resizeObserver.observe(underTableRef.current);

		return () => resizeObserver.disconnect();
	}, [getTopPerfomingChargerRows, getUnderPerformingChargerRows]);

	return (
		<div className='noc-charger-report'>
			<HorizontalNavbar
				selectedNav={navBarconfigurations?.selectedNav}
				navList={navBarconfigurations?.navList}
				onNavClick={(event, val) => {
					event?.stopPropagation();
					navBarconfigurations?.onNavClick?.(val);
				}}
			/>
			<div className='noc-charger-report-table-container'>
				<div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
					<div style={{ marginTop: '8px' }}>
						<svg
							width='10'
							height='10'
							viewBox='0 0 16 16'
							xmlns='http://www.w3.org/2000/svg'
						>
							<polygon points='8,2 14,14 2,14' fill='#16A34A' />
						</svg>
					</div>
					<div className='noc-charger-report-heading'>
						Top Perfoming Chargers
					</div>
				</div>
				<div ref={topTableRef} style={{ height: '100%' }}>
					<DataGridPro
						rows={getTopPerfomingChargerRows() ?? []}
						columns={perfomingChargerColumns}
						disableColumnMenu
						disableColumnReorder
						key={'noc-charger-report-table'}
						className={'noc-charger-report-table'}
						rowHeight={topRowHeight}
						// autoHeight={true}
						columnHeaderHeight={20}
						loading={false}
						slots={{
							footer: () => null,
						}}
						getRowClassName={(): string => {
							return 'noc-charger-report-table-row';
						}}
						sx={{
							'& .MuiDataGrid-columnHeaderTitle': {
								color: 'rgba(63, 63, 63, 1)',
								fontSize: '12px',
							},
							'& .MuiDataGrid-columnHeadersInner': {
								height: '20px',
							},
							'& .css-yrdy0g-MuiDataGrid-columnHeaderRow': {
								height: '20px',
							},
							'& .MuiDataGrid-columnHeader': {
								height: '20px !important',
								minHeight: '20px !important',
								maxHeight: '20px !important',
								lineHeight: '20px !important',
							},
							'& .MuiDataGrid-columnHeaders': {
								height: '30px !important',
								minHeight: '30px !important',
								maxHeight: '30px !important',
								lineHeight: '30px !important',
							},
						}}
					/>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
					<div style={{ marginTop: '8px' }}>
						<svg
							width='10'
							height='10'
							viewBox='0 0 16 16'
							xmlns='http://www.w3.org/2000/svg'
						>
							<polygon points='2,2 14,2 8,14' fill='#DC2626' />
						</svg>
					</div>
					<div className='noc-charger-report-heading'>
						Under Perfoming Chargers
					</div>
				</div>
				<div ref={underTableRef} style={{ height: '100%' }}>
					<DataGridPro
						rows={getUnderPerformingChargerRows() ?? []}
						columns={perfomingChargerColumns}
						disableColumnMenu
						disableColumnReorder
						rowHeight={underRowHeight}
						// autoHeight={true}
						columnHeaderHeight={40}
						hideFooter
						sx={{
							'& .MuiDataGrid-columnHeaderTitle': {
								color: 'rgba(63, 63, 63, 1)',
								fontSize: '12px',
							},
							'& .MuiDataGrid-columnHeadersInner': {
								height: '20px',
							},
							'& .css-yrdy0g-MuiDataGrid-columnHeaderRow': {
								height: '20px',
							},
							'& .MuiDataGrid-columnHeader': {
								height: '20px !important',
								minHeight: '20px !important',
								maxHeight: '20px !important',
								lineHeight: '20px !important',
							},
							'& .MuiDataGrid-columnHeaders': {
								height: '30px !important',
								minHeight: '30px !important',
								maxHeight: '30px !important',
								lineHeight: '30px !important',
							},
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default AcNocChargerReport;
